import { z } from "zod/v4";
const PostalCodeSchema = z
    .string()
    .regex(/^[0-9]{3}-[0-9]{4}$/)
    .brand();
export const PostalCode = {
    schema: PostalCodeSchema,
};
//# sourceMappingURL=postal-code.js.map